const STEPS = [
  {
    step: 'STEP 1',
    title: '資料をアップロード',
    description: '企画書、提案書、WBS、議事録、仕様書などをアップロードします。',
    icon: 'ri-upload-cloud-2-line',
  },
  {
    step: 'STEP 2',
    title: 'AIの提案を確認して承認',
    description: 'AIがタスク、担当者、期限、依存関係、マイルストーンを提案します。',
    icon: 'ri-check-double-line',
  },
  {
    step: 'STEP 3',
    title: '今日やることが毎朝分かる',
    description: '承認された計画をもとに、メンバーごとの今日のタスクを表示します。',
    icon: 'ri-sun-line',
  },
];

export default function HowToUse() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
          プロジェクト開始まで、わずか3ステップ
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STEPS.map((item, idx) => (
            <div key={item.step} className="text-center relative">
              {idx < STEPS.length - 1 && (
                <div className="hidden md:block absolute top-8 left-[60%] w-[80%] h-0.5 bg-background-300">
                  <i className="ri-arrow-right-s-line absolute right-0 -top-2 text-background-400 text-lg"></i>
                </div>
              )}
              <div className="w-16 h-16 mx-auto bg-primary-500 rounded-full flex items-center justify-center mb-4">
                <i className={`${item.icon} text-background-50 text-2xl`}></i>
              </div>
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
                {item.step}
              </span>
              <h3 className="text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}